// import List from '@/components/list';
// import More from '@/assets/images/common/svg/more.svg?react';
import { useChatContext } from '@/contexts/chat/context';
import { useSessionContext } from '@/contexts/session/context';
import { GroupEncryptionStatus } from '@/configs/apis/groups/interface';
import SearchMembers from '@/components/search-members';
import { useSearchMembersState } from '@/components/search-members/useSearchMembersState';
import type { GroupCreateProps } from './interface';
import styles from './index.module.scss';
import SelectedMembers from './selected-members';
import SelectAllMembers from './select-all-members';
// import Category from './category';

export default function GroupCreate({ open, onCancel }: GroupCreateProps) {
  const [loading, setLoading] = useState(false);
  const { createChat, activeChat } = useChatContext();
  const {
    session: { user },
  } = useSessionContext();
  const [groupName, setGroupName] = useState<string>('');
  const [isEncryption, setIsEncryption] = useState<GroupEncryptionStatus>(
    GroupEncryptionStatus.IS
  );

  const {
    selectedMembers,
    setSelectedMembers,
    membersList,
    updateMembersList,
    onSelect,
    onMemberDelete,
    onAllSelect,
    allSelectedMembers,
  } = useSearchMembersState();

  const createGroup = useCallback(async () => {
    try {
      if (loading) return;
      setLoading(true);
      const chat = await createChat({
        users: selectedMembers,
        group_name: groupName.trim() || `${user?.name}'s group`,
        is_encryption: isEncryption,
      });
      message.success('Group created successfully');
      setLoading(false);
      onCancel();
      if (chat) {
        activeChat(chat.chat_id);
      }
    } catch (err) {
      setLoading(false);
      throw err;
    }
  }, [
    loading,
    createChat,
    selectedMembers,
    groupName,
    user?.name,
    isEncryption,
    onCancel,
    activeChat,
  ]);

  useLayoutEffect(() => {
    if (open) {
      setGroupName('');
      setSelectedMembers([]);
      updateMembersList({
        contacts: [],
        members: [],
        users: [],
      });
    }
  }, [open, setSelectedMembers, updateMembersList]);

  return (
    <Modal
      open={open}
      destroyOnHidden
      title="New group"
      onCancel={onCancel}
      centered
      width={730}
      maskClosable={false}
      styles={{
        content: {
          padding: '24px 16px',
        },
      }}
      footer={
        <Flex gap={16} justify="end">
          <Button onClick={onCancel}>Cancel</Button>
          <Button
            type="primary"
            loading={loading}
            onClick={createGroup}
            disabled={selectedMembers.length === 0}
          >
            Create
          </Button>
        </Flex>
      }
    >
      <div className={styles.groupCreate}>
        {/* {selectedContacts.length > 0 && (
          <div className={styles.selectedContacts}>
            <div className={styles.selectedContactsList}>
              {selectedContacts.map((contact) => (
                <MyAvatar
                  key={contact.id}
                  src={getAvatar(contact.avatar, contact.name)}
                />
              ))}
            </div>
            <More />
          </div>
        )} */}
        {/* <div className={styles.groupList}>
          <List
            title="Group Type"
            gap={8}
            content={<span style={{ color: '#A3A3A3' }}>Chat</span>}
          />
        </div>
        <div className={styles.category}>
          <Category />
        </div> */}
        <div className={styles.contacts}>
          <Descriptions
            column={1}
            colon={false}
            styles={{
              label: {
                width: 135,
                color: '#1A1A1A',
              },
            }}
            items={[
              // {
              //   key: 'GroupType',
              //   label: 'Group Type',
              //   children: <Checkbox checked>Chat</Checkbox>,
              // },
              // {
              //   key: 'Group Avatar',
              //   label: 'Group Avatar',
              //   children: null,
              // },
              {
                key: 'GroupEncryption',
                label: 'Group Encryption',
                children: (
                  <Radio.Group
                    onChange={(e) => setIsEncryption(e.target.value)}
                    value={isEncryption}
                  >
                    <Radio value={GroupEncryptionStatus.IS}>Encryption</Radio>
                    <Radio value={GroupEncryptionStatus.NO}>No encryption</Radio>
                  </Radio.Group>
                ),
              },
              {
                key: 'GroupName',
                label: 'Group Name',
                children: (
                  <Input.TextArea
                    showCount
                    maxLength={60}
                    value={groupName}
                    rows={1}
                    onChange={(e) => setGroupName(e.target.value)}
                    placeholder="Enter Group Name (optional)"
                    style={{ resize: 'none' }}
                  />
                ),
              },
              // {
              //   key: 'GroupDescription',
              //   label: 'Group Description',
              //   children: (
              //     <Input.TextArea
              //       showCount
              //       maxLength={100}
              //       placeholder="Enter Group Description (optional)"
              //     />
              //   ),
              // },
              {
                key: 'GroupMembers',
                label: 'Group Members',
                children: (
                  <Card
                    className={styles.membersCard}
                    styles={{
                      body: {
                        padding: 0,
                        width: '100%',
                        display: 'flex',
                      },
                    }}
                  >
                    <div className={styles.membersCardContent}>
                      <div className={styles.orgList}>
                        <SearchMembers
                          membersList={membersList}
                          updateMembersList={updateMembersList}
                          selectedList={selectedMembers}
                          onSelect={onSelect}
                        />
                        <SelectAllMembers
                          className={styles.selectAll}
                          selectedMembers={selectedMembers}
                          allSelectedMembers={allSelectedMembers}
                          onAllSelect={onAllSelect}
                        />
                      </div>
                      <SelectedMembers
                        selectedMembers={selectedMembers}
                        onMemberDelete={onMemberDelete}
                      />
                    </div>
                  </Card>
                ),
              },
            ]}
          />
        </div>
      </div>
    </Modal>
  );
}
